var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},_vm._l((_vm.choices),function(choice,index){return _c('div',{key:index,staticClass:"d-flex flex-wrap justify-content-center"},[_c('div',{staticClass:"pb-2"},[_c('badge-pill',{attrs:{"text":choice}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }